/**
 * GOVOPS-1300 — municipal payments, search, notifications, vendors.
 */
import { assertGovOpsEntitlement, getGovOpsClient } from './govopsPermitService';
import { orgQueryParams } from './govopsConfig';

function orgQuery() {
  return orgQueryParams();
}

export async function searchGovOps(q) {
  await assertGovOpsEntitlement();
  const res = await getGovOpsClient().search({ ...orgQuery(), q });
  return res?.results || [];
}

export async function fetchMunicipalKpis() {
  await assertGovOpsEntitlement();
  const res = await getGovOpsClient().fetchMunicipalOperations(orgQuery());
  return res?.kpis || { unpaidPermits: 0, overduePayments: 0, renewalsDue: 0 };
}

export async function fetchPermitPayments(permitId) {
  await assertGovOpsEntitlement();
  const res = await getGovOpsClient().listPermitPayments(permitId);
  return res?.payments || [];
}

export async function recordPermitPayment(permitId, payload) {
  await assertGovOpsEntitlement();
  const res = await getGovOpsClient().recordPermitPayment(permitId, payload);
  return res?.permit;
}

export async function sendPermitRenewalNotice(permitId, payload = {}) {
  await assertGovOpsEntitlement();
  const res = await getGovOpsClient().sendRenewalNotice(permitId, payload);
  return res?.permit;
}

export async function renewGovOpsPermit(permitId, payload = {}) {
  await assertGovOpsEntitlement();
  const res = await getGovOpsClient().renewPermit(permitId, payload);
  return res?.permit;
}

export async function fetchVendors() {
  await assertGovOpsEntitlement();
  const res = await getGovOpsClient().listVendors(orgQuery());
  return res?.vendors || [];
}

export async function createVendor(payload) {
  await assertGovOpsEntitlement();
  const res = await getGovOpsClient().createVendor({ ...orgQuery(), ...payload });
  return res?.vendor;
}

export async function fetchVendorPermits(vendorId) {
  await assertGovOpsEntitlement();
  const res = await getGovOpsClient().listVendorPermits(vendorId, orgQuery());
  return res?.permits || [];
}
